import { UploadSimpleIcon } from "@phosphor-icons/react";
import { useTranslation } from "@/features/utils/i18n";
import { formatFileSize } from "@/features/utils/numbers";
import { twMerge } from "tailwind-merge";
import { getPlaceholderKey } from "./helpers";
import type { FileType } from "./types";

interface EmptyStateProps {
  type: FileType;
  maxSize: number;
  isDragging: boolean;
  disabled: boolean;
  className?: string;
  onDragOver: (e: React.DragEvent) => void;
  onDragLeave: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  onClick: () => void;
}

export const EmptyState = ({
  type,
  maxSize,
  isDragging,
  disabled,
  className,
  onDragOver,
  onDragLeave,
  onDrop,
  onClick,
}: EmptyStateProps) => {
  const { t } = useTranslation("fileUpload");
  return (
    <div
      className={twMerge(
        "relative border border-input border-dashed rounded-sm p-8 transition-colors cursor-pointer",
        isDragging
          ? "border-primary bg-primary/5"
          : "border-input hover:border-slate-400",
        disabled && "opacity-50 cursor-not-allowed",
        className,
      )}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      onClick={onClick}
    >
      <div className="flex flex-col items-center gap-2 text-center">
        <UploadSimpleIcon
          className="h-6 w-6 text-muted-foreground"
          weight="fill"
        />
        <p className="text-sm text-muted-foreground">
          {t(`placeholder.${getPlaceholderKey(type)}`)}
        </p>
        <p className="text-xs text-muted-foreground">
          {t("maxSize", { size: formatFileSize(maxSize) })}
        </p>
      </div>
    </div>
  );
};
